var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPytorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.005 0.052002L6.63599 9.427C5.40374 10.6458 4.42548 12.0969 3.75783 13.6964C3.09017 15.2958 2.7464 17.0118 2.7464 18.745C2.7464 20.4782 3.09017 22.1942 3.75783 23.7936C4.42548 25.3931 5.40374 26.8442 6.63599 28.063C7.85462 29.2943 9.30529 30.2718 10.9041 30.9389C12.5029 31.606 14.2181 31.9495 15.9505 31.9495C17.6829 31.9495 19.3981 31.606 20.9969 30.9389C22.5957 30.2718 24.0464 29.2943 25.265 28.063C30.562 22.875 30.562 14.5 25.38 9.427L23.063 11.74C26.922 15.599 26.922 21.885 23.063 25.745C19.203 29.604 12.918 29.604 9.05799 25.745C5.19799 21.885 5.19799 15.598 9.05799 11.74L15.235 5.568L16.011 4.683L16.005 0.052002ZM20.749 5.235C19.776 5.235 18.984 6.027 18.984 7C18.9844 7.34852 19.0881 7.6891 19.2819 7.97872C19.4758 8.26834 19.7512 8.49399 20.0732 8.62718C20.3953 8.76037 20.7496 8.79512 21.0914 8.72703C21.4332 8.65894 21.7472 8.49107 21.9936 8.24463C22.2401 7.99819 22.4079 7.68424 22.476 7.34244C22.5441 7.00063 22.5094 6.64632 22.3762 6.32425C22.243 6.00219 22.0173 5.72683 21.7277 5.53295C21.4381 5.33908 21.0975 5.2354 20.749 5.235Z",
    fill: "#FA6613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/pytorch.ecf22176c76d658baa72ff4bd36a80c6.svg";
export { ForwardRef as ReactComponent };